import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { DisabledStatus } from "@nxplatform/platform-entities";
import { CustomerBasicModal } from "@nxplatform/platform-entities/customer/customer-enum-types";
import { allowedLinks } from "@nxplatform/platform-settings/locale-setup.routes";
import { customerOpenBasicModal } from "@nxplatform/store-shared/customer/shared-customer-actions";
import { selectCustomerEntities, selectIsGviveMigrationInProgress } from "@nxplatform/store-shared/customer/shared-customer-selectors";
import { setCashierMethod, setDepositBonusCode } from "../customer-cashier.slice.js";
const useOpenCashierModal = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const customer = useSelector(selectCustomerEntities);
  const gviveMigrationInProgress = useSelector(selectIsGviveMigrationInProgress);
  const openCashierModal = (params) => {
    const { method, bonusCode } = params || {};
    if (customer && customer.disabledStatusCode === DisabledStatus.block_id_upload) {
      if (pathname !== allowedLinks.blockedVerification) {
        window.location.href = `${allowedLinks.blockedVerification}`;
      }
      return;
    }
    if (customer && gviveMigrationInProgress) {
      if (pathname !== allowedLinks.registrationMigrationGvive) {
        window.location.href = `${allowedLinks.registrationMigrationGvive}`;
      }
      return;
    }
    dispatch(customerOpenBasicModal(CustomerBasicModal.cashier));
    if (method) {
      dispatch(setCashierMethod(method));
    }
    if (bonusCode) {
      dispatch(setDepositBonusCode(bonusCode));
    }
  };
  return { openCashierModal };
};
export {
  useOpenCashierModal
};
